import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TipoClassificacaoCadastroMultiselectComponent } from './multiselect';
import { TipoClassificacaoCadastroPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TipoClassificacaoCadastroMultiselectComponent,

        // Pipes
        TipoClassificacaoCadastroPipe
    ],
    exports: [
        TipoClassificacaoCadastroMultiselectComponent,

        // Pipes
        TipoClassificacaoCadastroPipe
    ],
    providers: [
        // Pipes
        TipoClassificacaoCadastroPipe
    ]
})
export class TipoClassificacaoCadastroModule { }
